/**
 * The handlers that start the Google sign-in script download when a signed-out reader shows
 * intent on a sign-in entry point — hover, press, or keyboard focus, each a beat before the click
 * that opens the dialog. Spread them on the element; `prewarm` is the auth container's
 * `prewarmGoogle` (a no-op when signed in). Absent → `{}`, so spreading changes nothing.
 *
 * Intent only, never scroll or visibility: the script costs page speed, and a reader who never
 * reaches for sign-in should never download it (One Tap's own load is for returning devices).
 *
 * A plain function, not a hook: each entry point already reads the auth container its own way
 * (required, optional, or through `useCommentHub`) and passes `prewarm` in.
 */
export interface GoogleSignInIntentHandlers {
  onPointerEnter?: () => void
  onPointerDown?: () => void
  onFocus?: () => void
}

export function googleSignInIntent(prewarm: (() => void) | undefined): GoogleSignInIntentHandlers {
  if (!prewarm) {
    return {}
  }
  return { onPointerEnter: prewarm, onPointerDown: prewarm, onFocus: prewarm }
}
